import { useCallback, useState } from "react";

const useToggleOpen = () => {
  const [isOpen, setIsOpen] = useState(false);

  const toggleOpen = useCallback(() => {
    setIsOpen((currentIsOpen) => !currentIsOpen);
  }, []);

  return { isOpen, toggleOpen };
};

export default useToggleOpen;
